import React from "react";
import { siteData } from "../mock";
import { Check } from "lucide-react";

const Mission = () => {
  const { mission } = siteData;
  return (
    <section id="mission" className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <p className="text-[#4a90c2] font-semibold uppercase tracking-[0.18em] text-sm ht-body">
              {mission.eyebrow}
            </p>
            <h2 className="mt-4 ht-display text-3xl sm:text-4xl lg:text-5xl text-[#2c3e50] leading-[1.1]">
              {mission.title}
            </h2>
            <p className="mt-6 ht-body text-[#5a6b7d] text-base sm:text-lg leading-relaxed">
              {mission.body}
            </p>
            <p className="mt-6 font-semibold text-[#2c3e50] ht-body">
              {mission.offerTitle}
            </p>
            <ul className="mt-5 space-y-4">
              {mission.offers.map((o) => (
                <li key={o.title} className="flex gap-3">
                  <span className="mt-1 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#cfe7f8]">
                    <Check className="h-3.5 w-3.5 text-[#3d6486]" />
                  </span>
                  <p className="ht-body text-[#2c3e50]">
                    <span className="font-semibold">{o.title}:</span>{" "}
                    <span className="text-[#5a6b7d]">{o.text}</span>
                  </p>
                </li>
              ))}
            </ul>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-xl ring-1 ring-[#e2eaf2]">
              <img
                src={mission.image}
                alt="Birds gathered together"
                className="w-full h-[420px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#3d4e62]/35 via-transparent to-transparent" />
              <div className="absolute top-6 left-1/2 -translate-x-1/2">
                <span className="inline-block px-4 py-1.5 rounded-full bg-[#cfe7f8] text-[#2c3e50] text-xs font-semibold tracking-wide">
                  Community
                </span>
              </div>
              <div className="absolute inset-x-0 bottom-10 text-center">
                <h3 className="ht-display text-white text-3xl drop-shadow-md">
                  Never Alone
                </h3>
              </div>
            </div>
            <div className="absolute -inset-4 -z-10 rounded-3xl bg-gradient-to-br from-[#eaf4fb] to-[#dfeefa] blur-2xl opacity-70" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
